import { flightItineraryHelpers } from './base'

const primaryTeal = 'var(--chakra-colors-brand-primaryTeal)'
const alBlack = 'brand.black'
const alCoolGrey10 = 'brand.coolgrey10'

export const FlightItineraryProp = flightItineraryHelpers.defineMultiStyleConfig({
  baseStyle: flightItineraryHelpers.definePartsStyle({
    title: {
      color: primaryTeal,
    },
    departureDateTime: {
      color: alBlack,
    },
    airportName: {
      color: alCoolGrey10,
    },
    terminal: {
      color: alBlack,
    },
    iataCode: {
      color: alBlack,
    },
    flightTime: {
      color: primaryTeal,
    },
    flightClass: {
      color: alCoolGrey10,
    },
    arrow: {
      backgroundColor: 'brand.primaryTeal',
    },
    arrow_left: {
      borderTop: '5px solid transparent',
      borderBottom: '5px solid transparent',
      borderLeft: `5px solid ${primaryTeal}`,
    },
  }),
})
